export default __webpack_public_path__ + "static/547-2baf86ef633319022cdad542eefb063a.gif";